export const formatNumber = (num: number | string): string => {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const fractionalPart = parts[1] ? "." + parts[1] : "";

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    return formattedIntegerPart + fractionalPart;
};
